import { render, staticRenderFns } from "./VDealLeadInfo.vue?vue&type=template&id=de27e896"
import script from "./VDealLeadInfo.vue?vue&type=script&lang=js"
export * from "./VDealLeadInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports